<template src="./detalhes-do-produto.html"></template>
<style lang="less" src="./detalhes-do-produto.less" scoped></style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import stringHelper from "@/helpers/string.helper";
import Dropdown from "@/modules/loja/produto/grade/dropdown/dropdown-grade/dropdown-grade";
import Card from "@/components/cards/card/card";
import Currency from "@/filters/currency/currency.filter";
import BtnWhatsapp from "@/components/buttons/btn-whatsapp/btn-whatsapp";
import ImagemNaoDisponivel from "@/modules//loja/produto/components/imagem-nao-disponivel/imagem-nao-disponivel";
import Loading from "@/components/loadings/loading/loading";
import BtnAdicionarNoCarrinho from "@/components/buttons/btn-adicionar-no-carrinho/btn-adicionar-no-carrinho";
import categoria from "@/mixins/categoria.mixin";
const DetalhesDoProduto = "DetalhesDoProduto";
const PerfilDaLoja = "PerfilDaLoja";
const MenuCategoriasProduto = "MenuCategoriasProduto";
const Grade = "Grade";
const ProdutoEhKit = 1;
const ListagemDeProduto = "ListagemDeProduto";

export default {
  mixins: [categoria],
  filters: {
    Currency,
  },
  components: {
    Card,
    BtnWhatsapp,
    ImagemNaoDisponivel,
    Loading,
    Dropdown,
    BtnAdicionarNoCarrinho,
  },
  created() {
    const { id } = this.$route.params;

    if (!id) return this.irParaPaginaDaListagem();

    this.limparDetalhes();

    this.fetchById({
      produtoId: id,
      errorCallback: this.irParaAPaginaNaoEncontrada,
      successCallback: this.atualizarQtdEstoque,
    });

    this.buscarCategorias();
  },
  data(){
      return {
          currentImgSrc: null
      }
  },
  computed: {
    ...mapState(PerfilDaLoja, ["perfil"]),
    ...mapState(DetalhesDoProduto, ["loading", "produto"]),
    ...mapState(Grade, [
      "gradePrimariaSelecionadaId",
      "gradeSecundariaSelecionadaId",
      "qtdEstoque",
      "gradePrimaria",
      "gradeSecundaria"
    ]),
    ...mapGetters(PerfilDaLoja, [
      "getNumeroCelularCompleto",
      "getLocalDeEstoqueId",
      "getQuantidadeMinimaEstoqueExibicao",
    ]),
    mostrarAvisoEstoqueBaixo() {
      return (
        this.getQuantidadeMinimaEstoqueExibicao > 0 &&
        this.qtdEstoque > 0 &&
        this.qtdEstoque <= this.getQuantidadeMinimaEstoqueExibicao &&
        (!this.gradePrimaria?.length || this.gradePrimariaSelecionadaId) &&
        (!this.gradeSecundaria?.length || this.gradeSecundariaSelecionadaId)
      );
    },
    mensagemAvisoEstoqueBaixo() {
      return this.qtdEstoque === 1 
        ? `Resta apenas 1 unidade, corre!` 
        : `Restam apenas ${this.qtdEstoque} unidades, corre!`; 
    },
    disponivel() {
      if(this.gradePrimaria?.length && !this.gradePrimariaSelecionadaId) return true;
      if(this.gradeSecundaria?.length && !this.gradeSecundariaSelecionadaId) return true;
      return this.qtdEstoque > 0;
    },
    mensagem() {
      return this.disponivel
        ? `Olá, eu estou interessado no seu produto *${(
            this.produto?.nome || ""
          ).toUpperCase()}* (${location.href}).`
        : `Olá, avise-me quando o produto *${(
            this.produto?.nome || ""
          ).toUpperCase()}* (${location.href}) estiver disponível.`;
    },

    haveMultiplesImgs(){
        return this.produto?.imagensSrc?.length > 1;
    }
  },
  watch: {
      produto(value) {
          if(value?.imagensSrc?.length) {
              this.currentImgSrc = value.imagensSrc[0]
          } else {
              this.currentImgSrc = null
          }
      }
  },
  methods: {
    ...mapActions(DetalhesDoProduto, ["fetchById", "limparDetalhes"]),
    ...mapActions(MenuCategoriasProduto, ["buscarCategorias"]),
    ...mapActions(Grade, ["fetchQtdEstoque"]),
    ...mapActions(ListagemDeProduto, ["setCategoriaId"]),

    irParaPaginaDaListagem(categoriaId = null) {
      this.setCategoriaId({ categoriaId, fetchProdutos: false});
      this.$router.push({ name: "produto-listagem" });
    },
    irParaAPaginaNaoEncontrada() {
      this.$router.push({ name: "pagina-nao-encontrada" });
    },
    getNomeDoProdutoFormatado(nomeProduto) {
      return stringHelper.FormatarStringCompridaComReticencias(nomeProduto);
    },
    getNomeCategoria() {
      return this.produto.nomeCategoriaDoProdutoNivelTres ||
        this.produto.nomeCategoriaDoProdutoPai ||
        this.produto.nomeCategoriaDoProduto ||
        "Sem categoria";
    },
    getIdCategoria() {
      return this.produto.categoriaDoProdutoNivelTresId ||
        this.produto.categoriaDoProdutoPaiId ||
        this.produto.categoriaDoProdutoId ||
        "";
    },
    atualizarQtdEstoque() {
      this.fetchQtdEstoque({
        localDeEstoqueId: this.getLocalDeEstoqueId,
        produtoPrincipalId: this.produto.id,
        gradePrimariaId: this.gradePrimariaSelecionadaId,
        gradeSecundariaId: this.gradeSecundariaSelecionadaId,
      });
    },
    setCurrentImgSrc(imgSrc) {
        this.currentImgSrc = imgSrc;
    }
  },
};
</script>